import React from "react";
import Slider from "react-slick";
import "./PlantationTwoServices.scss";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const PlantationTwoServices = () => {
  const { documents: products } = useCollection("products");
  const topSelling =
    products?.filter((item) => item.newArrivals === true) || [];

  const navigate = useNavigate();

  const fallbackColors = [
    "#f89c1e",
    "#0ba7b3",
    "#f77a8b",
    "#6a5acd",
    "#1abc9c",
    "#ff6347",
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4, // Show 4 cards on large screens
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true, // Show arrows for easier navigation
    responsive: [
      {
        breakpoint: 1200, // For screens smaller than 1200px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900, // For tablets and smaller laptops
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // For mobiles
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendDots: (dots) => <ul className="custom-dots">{dots}</ul>,
    customPaging: () => <div className="dot" />,
  };

  const formatPrice = (price) => {
    if (!price) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="plantation-two-carousel-wrapper-services">
      <h2 className="plantation-services-heading">Hot New Picks</h2>
      <Slider {...settings}>
        {topSelling.map((item, index) => (
          <div className="card-wrapper" key={item.id || index}>
            <div className="card">
              <div
                className="card-inner"
                style={{
                  backgroundColor:
                    item.bgColor ||
                    fallbackColors[index % fallbackColors.length],
                }}
              >
                <div className="top">
                  <div className="text">
                    <h3>{item.name || item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                  <div className="price">{formatPrice(item.price)}</div>
                </div>

                <div className="image-box">
                  <img
                    src={
                      Array.isArray(item.images)
                        ? item.images[0] || "/fallback-image.jpg"
                        : item.image || "/fallback-image.jpg"
                    }
                    alt="product"
                    className="circle-image"
                  />
                </div>

                <div className="bottom">
                  <div className="rating">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon
                        key={i}
                        className={
                          i < Math.round(item.rating || 0) ? "filled" : "empty"
                        }
                      />
                    ))}
                  </div>
                  <button
                    className="cart-btn"
                    onClick={() => navigate(`/product-details-two/${item.id}`)}
                  >
                    Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PlantationTwoServices;
